import { FaStarHalfAlt, FaStar, FaRegStar } from "react-icons/fa"

export function ReviewStars({ rating, className = '', starClass = '', size = 24 }: { rating: number; className?: string; starClass?: string; size?: number }) {
  const stars = []
  const fullStars = Math.floor(rating)
  const fraction = rating - fullStars
  const hasHalf = fraction >= 0.4
  for (let i = 0; i < 5; i++) {
    if (i < fullStars) {
      stars.push(<FaStar size={size} key={i} className={`homerunner-review-stars-full inline text-yellow-500 ${starClass}`} fill="currentColor" />)
    } else if (i === fullStars && hasHalf) {
      stars.push(<FaStarHalfAlt size={size} key={i} className={`homerunner-review-stars-half inline text-yellow-500 ${starClass}`} fill="currentColor" />)
    } else {
      stars.push(<FaRegStar size={size} key={i} className={`homerunner-review-stars-empty inline text-yellow-500 ${starClass}`} />)
    }
  }
  return <span className={`homerunner-review-stars flex items-center gap-0.5 ${className}`}>{stars}</span>
}

export default ReviewStars
